<div class="sh-form-group" [class.-sh-is-invalid]="recordControl.invalid">
    <sh-form-label [label]="label" [for]="id" [required]="true"></sh-form-label>
    <div class="sh-input-field-with-action">
        <input
            #scannerInput
            type="text"
            class="sh-input-field sh-form-group__input ng-untouched ng-pristine ng-valid"
            [id]="id"
            [formControl]="recordControl"
            (keydown.enter)="handleRecordScan()"
        />
        <sh-action-item class="sh-action-group__item" [item]="this.scanAction$ | async"></sh-action-item>
    </div>
    @if (recordControl.invalid) {
        <div class="sh-form-group__feedback">
            <p>{{ recordControl.getError('message') || 'form.error.required-field' | translate }}</p>
        </div>
    }
</div>
